// Regras do formulário de cliente. Devolve { campo: mensagem }; vazio = válido
export const validate = (form, { requiredKnowWay, notShowPost }) => {
  const errors = {}

  if (!form.name) errors.name = 'O campo nome é obrigatório'

  if (!form.phone) errors.phone = 'O campo telefone 1 é obrigatório'

  if (requiredKnowWay && !form.know_way_id)
    errors.know_way_id = 'O como soube é obrigatório'

  if (
    !notShowPost &&
    form.commission_percent &&
    (form.commission_percent < 0.01 || form.commission_percent > 100)
  )
    errors.commission_percent = 'O valor deve estar entre 0,01 até 100'

  return errors
}
